export default "__VITE_ASSET__e40d5226__"